module.exports = __webpack_public_path__ + "static/img/bottom_dec.0702e571.png";